
        // =======================================================================
        // Canonical ratings — the SINGLE SOURCE OF TRUTH for what every band,
        // severity and exposure grade means and looks like on screen. Mirrors
        // app/services/ratings.py exactly: same 0-5 cut points (2.5 / 3.5 / 4.5),
        // same words, same colours. A rating shown on the dashboard is the same
        // rating printed in the report. Change one, change both.
        // =======================================================================
        const RATINGS = {
            bandOrder: ['low', 'moderate', 'high', 'critical'],
            bandLabel: { low: 'Low', moderate: 'Moderate', high: 'High', critical: 'Critical' },
            bandHex:   { low: 'var(--green)', moderate: 'var(--gold)', high: 'var(--amber)', critical: 'var(--red)' },
            // Map a 0-5 composite to its band key.
            bandForScore(score) {
                const c = Number(score);
                if (!isFinite(c)) return 'low';
                if (c >= 4.5) return 'critical';
                if (c >= 3.5) return 'high';
                if (c >= 2.5) return 'moderate';
                return 'low';
            },
            // Colour for a band key ('high'), a raw composite (4.2), or a severity.
            hex(bandOrScore) {
                if (typeof bandOrScore === 'number') return this.bandHex[this.bandForScore(bandOrScore)];
                const k = String(bandOrScore || '').toLowerCase();
                return this.bandHex[k] || this.bandHex.low;
            },
            label(bandOrScore) {
                if (typeof bandOrScore === 'number') return this.bandLabel[this.bandForScore(bandOrScore)];
                const k = String(bandOrScore || '').toLowerCase();
                return this.bandLabel[k] || (k ? k[0].toUpperCase() + k.slice(1) : '—');
            },
            severityRank: { critical: 0, high: 1, moderate: 2, low: 3 },
            // Exposure posture grade A(best)-F(worst) → the same four-colour palette.
            gradeHex(g) {
                const c = String(g || '').toUpperCase()[0];
                if (c === 'A' || c === 'B') return 'var(--green)';
                if (c === 'C') return 'var(--gold)';
                if (c === 'D') return 'var(--amber)';
                if (c === 'E' || c === 'F') return 'var(--red)';
                return 'var(--text-muted)';
            },
        };

export { RATINGS };
